import React from 'react'
import { classNames, variationName } from './../../utils/styles'
import PropTypes from 'prop-types'
import * as styles from './DisplayText.scss'

export default function DisplayText({ Element = 'p', children, size = 'medium', color, className }) {
  const classes = classNames(
    styles.DisplayText,
    size && styles[variationName('size', size)],
    color && styles[variationName('color', color)],
    className && className,
  )

  return <Element className={classes}>{children}</Element>
}

DisplayText.propTypes = {
  Element: PropTypes.string,
  children: PropTypes.any,
  size: PropTypes.string,
  color: PropTypes.string,
  className: PropTypes.string,
}



// WEBPACK FOOTER //
// ./src/components/DisplayText/index.js